import Lenis from 'lenis';

let lenis;
const listeners = new Set();
let snapshot = {
  progress: 0,
  activeIndex: 0,
  journeyBeat: 0,
  beatProgress: 0,
  isMobileFlat: false,
};

function getMaxScroll() {
  return Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
}

function computeSnapshot() {
  const progress = Math.min(1, Math.max(0, window.scrollY / getMaxScroll()));
  const activeIndex = Math.min(7, Math.max(0, Math.round(progress * 7)));
  const journeyPosition = progress * 8;
  const journeyBeat = Math.min(7, Math.max(0, Math.floor(journeyPosition)));
  const beatProgress = Math.min(1, Math.max(0, journeyPosition - journeyBeat));
  const isMobileFlat =
    window.matchMedia('(max-width: 760px), (pointer: coarse), (prefers-reduced-motion: reduce)').matches;
  snapshot = { progress, activeIndex, journeyBeat, beatProgress, isMobileFlat };
  listeners.forEach((listener) => listener(snapshot));
}

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
  lenis.on('scroll', computeSnapshot);
  window.addEventListener('resize', computeSnapshot, { passive: true });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
  computeSnapshot();
  return lenis;
}

export function getScrollSnapshot() {
  return snapshot;
}

export function scrollToTop() {
  if (lenis) {
    lenis.scrollTo(0, { immediate: true });
    computeSnapshot();
    return;
  }
  window.scrollTo({ top: 0, behavior: 'auto' });
  computeSnapshot();
}

export function scrollToTarget(hash, { immediate = false } = {}) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) {
    // immediate jumps happen right after a view remount; Lenis's debounced
    // dimensions can still reflect the previous (shorter) document, and
    // scrollTo clamps against that stale limit — re-measure first
    if (immediate) lenis.resize();
    lenis.scrollTo(el, { offset: hash === '#hero' ? 0 : -84, immediate });
    return;
  }
  el.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth' });
}

export function getLenis() {
  return lenis;
}

export function subscribeScroll(listener) {
  listeners.add(listener);
  listener(snapshot);
  return () => listeners.delete(listener);
}
